import { useQuery } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { RestorableEmploiDuTemps } from '@teetsh/app/src/types/edt';

export const EDTS_TRASH = 'edts_trash';

function fetchEDTsTrash() {
  const requestURL = '/emplois-du-temps/trash';
  return request(requestURL, {
    method: 'GET',
  }).then(({ data }: { data: RestorableEmploiDuTemps[] }) => data || []);
}

export function useEDTsTrash() {
  return useQuery({
    queryKey: [EDTS_TRASH],
    queryFn: () => fetchEDTsTrash(),
    placeholderData: [],
    refetchOnWindowFocus: false,
  });
}
